import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × MAISON KITSUNÉ: Geometry with a groove
// Fox tessellation, color-blocked stripes, electro gradients
export function VasarelyKitsuneMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="kitsune-electro1" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FF6B35" />
          <stop offset="50%" stopColor="#FFA500" />
          <stop offset="100%" stopColor="#FFD700" />
        </linearGradient>
        <linearGradient id="kitsune-electro2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00CED1" />
          <stop offset="50%" stopColor="#4169E1" />
          <stop offset="100%" stopColor="#6A5ACD" />
        </linearGradient>
      </defs>

      {/* White background */}
      <rect x="0" y="0" width="794" height="1123" fill="#FFFFFF" />

      <g transform="translate(397 540)">
        {/* Color-blocked stripes */}
        {[
          { y: -400, h: 100, fill: "#FF6B35" },
          { y: -300, h: 100, fill: "#FFA500" },
          { y: -200, h: 100, fill: "#FFD700" },
          { y: -100, h: 100, fill: "#00CED1" },
          { y: 0, h: 100, fill: "#4169E1" },
          { y: 100, h: 100, fill: "#6A5ACD" },
          { y: 200, h: 100, fill: "#FF69B4" },
          { y: 300, h: 100, fill: "#FF6B35" },
        ].map((stripe, i) => (
          <rect
            key={i}
            x="-397"
            y={stripe.y}
            width="794"
            height={stripe.h}
            fill={stripe.fill}
            opacity="0.15"
          />
        ))}

        {/* Fox tessellation pattern */}
        {Array.from({ length: 8 }).map((_, i) =>
          Array.from({ length: 12 }).map((_, j) => {
            const x = (i - 3.5) * 90;
            const y = (j - 5.5) * 80;
            const angle = ((i + j) % 4) * 90;
            
            return (
              <g key={`${i}-${j}`} transform={`translate(${x} ${y}) rotate(${angle})`}>
                {/* Stylized fox ear triangles */}
                <polygon
                  points="0,-20 -15,10 15,10"
                  fill={i % 2 === 0 ? "#FF6B35" : "#4169E1"}
                  opacity="0.6"
                />
                <polygon
                  points="0,-15 -10,5 10,5"
                  fill="#FFFFFF"
                  opacity="0.8"
                />
              </g>
            );
          })
        )}

        {/* Electro gradients circular */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 40 + i * 25;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 2 === 0 ? "url(#kitsune-electro1)" : "url(#kitsune-electro2)"}
              strokeWidth="2"
              opacity={0.4 - i * 0.025}
            />
          );
        })}

        {/* Geometric groove lines */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 280}
              y2={Math.sin(angle) * 280}
              stroke="#FF6B35"
              strokeWidth="1"
              opacity="0.15"
            />
          );
        })}

        {/* Central fox icon */}
        <circle cx="0" cy="0" r="60" fill="url(#kitsune-electro1)" opacity="0.3" />
        <polygon points="0,-40 -25,0 25,0" fill="#FF6B35" />
        <polygon points="0,-30 -15,-5 15,-5" fill="#FFFFFF" />
        <circle cx="-8" cy="-10" r="3" fill="#000000" />
        <circle cx="8" cy="-10" r="3" fill="#000000" />
      </g>

      {/* French-Japanese pop */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#FF6B35" fontWeight="600">
        FRENCH-JAPANESE POP ENERGY
      </text>
    </g>
  );
}
